import React from 'react';

import { OrganizationSelectorFormFooter } from './organization-selector-form-footer';
import { OrganizationSelectorRadioGroup } from './organization-selector-radio-group';

import Form from '@atlaskit/form';
import styled from 'styled-components';
import { messages } from '../messages';
import { FormattedMessage } from 'react-intl';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';

export type OrganizationSelectorFormProps = {
  readonly organizations: string[];
  readonly onNewOrganizationSelected: () => void;
  readonly onOrganizationSelected: (organization: string) => void;
  readonly onOrganizationChanged: () => void;
  readonly onSwitchAccountClick: () => void;
  readonly onCancelClick: () => void;
  readonly fullScreenView?: boolean;
};

export type FormData = {
  readonly organization: string;
};

export type FormProps = {
  readonly formProps: Record<string, unknown>;
  readonly submitting: boolean;
};

export const OrganizationSelectorForm = (
  props: OrganizationSelectorFormProps
) => {
  const handleFormSubmit = (data: FormData) => {
    const { onOrganizationSelected } = props;

    onOrganizationSelected(data.organization);
  };

  const renderFormContents = (
    formProps: Record<string, unknown>,
    submitting: boolean
  ) => {
    const {
      organizations,
      onSwitchAccountClick,
      onCancelClick,
      onOrganizationChanged,
      fullScreenView
    } = props;
    if (organizations.length === 0) {
      return (
        <form {...formProps} name="organization-selector">
          <HeaderText>
            <FormattedMessage {...messages.adminHeader} />
          </HeaderText>
          <BodyText>
            <SanitizedFormattedHtmlMessage {...messages.adminBody} />
          </BodyText>
          <OrganizationSelectorFormFooter
            admin={false}
            canSubmit={!submitting}
            onSwitchAccountClick={onSwitchAccountClick}
            onCancelClick={onCancelClick}
            fullScreenView={fullScreenView}
          />
        </form>
      );
    } else {
      return (
        <form {...formProps} name="organization-selector">
          <OrganizationSelectorRadioGroup
            organizations={organizations}
            onOrganizationChanged={onOrganizationChanged}
          />
          <OrganizationSelectorFormFooter
            canSubmit={!submitting}
            onSwitchAccountClick={onSwitchAccountClick}
            onCancelClick={onCancelClick}
            fullScreenView={fullScreenView}
            admin={true}
          />
        </form>
      );
    }
  };

  return (
    <Form testId="submit-form" onSubmit={handleFormSubmit}>
      {({ formProps, submitting }: FormProps) =>
        renderFormContents(formProps, submitting)
      }
    </Form>
  );
};

const HeaderText = styled.p`
  color: var(--neutral-light-n-900, #091e42);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Charlie Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 475;
  line-height: 24px; /* 150% */
  margin-bottom: 8px;
`;

const BodyText = styled.p`
  color: var(--neutral-light-n-900, #091e42);
  font-feature-settings: 'clig' off, 'liga' off;

  /* Body/P Normal */
  font-family: Charlie Text;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  margin-top: 8px;
`;
